// Material Dashboard 2 PRO React Base Styles
import colors from "assets/theme/base/colors";

const { info, dark, grey, secondary } = colors;

const globals = {
  html: {
    scrollBehavior: "smooth",
  },
  "*, *::before, *::after": {
    margin: 0,
    padding: 0,
  },
  "a, a:link, a:visited": {
    textDecoration: "none !important",
  },
  "a.link, .link, a.link:link, .link:link, a.link:visited, .link:visited": {
    color: `${dark.main} !important`,
    transition: "color 150ms ease-in !important",
  },
  "a.link:hover, .link:hover, a.link:focus, .link:focus": {
    color: `${info.main} !important`,
  },
  ".css-ekdnj9": {
    width: "100% !important",
  },
  ".css-27fnc9-MuiChip-root": {
    color: "white !important",
  },
  // scroll
  "::-webkit-scrollbar": {
    width: "6px",
    height: "6px",
    background: "#ddd",
  },
  "::-webkit-scrollbar-track": {
    background: "transparent",
    // boxShadow: "inset 0 0 5px grey",
    borderRadius: "10px",
  },
  "::-webkit-scrollbar-thumb": {
    background: grey[700],
    borderRadius: "10px",
  },
  "::-webkit-scrollbar-thumb:hover": {
    background: grey[800],
  },
  "::-moz-selection": {
    color: "white",
    background: secondary.main,
  },
  // css list
  ".css-yaydtu-MuiList-root": {
    listStyle: "none",
    margin: 0,
    padding: 0,
    position: "relative",
    paddingTop: 0,
    paddingBottom: 0,
    width: "100%",
    maxWidth: "100% !important",
    backgroundColor: "#fff",
  },
};

export default globals;
